import USERConfig from './systemManage/user'
import EXPERTConfig from './systemManage/expert'
import UNITEXPERTConfig from './systemManage/unitExpert'
import CUSTOMERConfig from './systemManage/customer'
import SENDEXPERTConfig from './thesisManage/sendExpert'
import SENDUNITConfig from './thesisManage/sendUnit' // 分配专家
import SENDEXPERTFROMUNITConfig from './thesisManage/sendExpertFromUnit'
import BATCHSENDEXPERTConfig from './thesisManage/batchSendExpert'
import BATCHSENDEXPERTFROMUNITConfig from './thesisManage/batchSendExpertFromUnit'
import BATCHSENDUNITConfig from './thesisManage/batchSendUnit'
import BATCHSENDUNITFROMUNITConfig from './thesisManage/batchSendUnitFromUnit'
import MENUConfig from './systemManage/menu'
import ROLEConfig from './systemManage/role'
import UNITConfig from './systemManage/unit'
import THESISConfig from './thesisManage/thesis'
import ACADEMYPROCESSOFTHESISConfig from './thesisManage/academyProcessOfThesis'
import STAYRECEIVEDTHESISConfig from './thesisManage/stayReceivedThesis'
import UNITUPLOADTHESISConfig from './thesisManage/unitUploadThesis'
import UNITUPLOADTHESIS2Config from './thesisManage/unitUploadThesis2' // 二级指派单位论文分配
import RETURNTHESISConfig from './thesisManage/returnThesis'
import REVIEWEDTHESISConfig from './thesisManage/reviewedThesis'
import UPLOADTHESISConfig from './thesisManage/uploadThesis'
import PROCESSOFTHESISConfig from './thesisManage/processOfThesis'
import MATCHEXPERTConfig from './thesisManage/matchExpert'
import EARLYWARNINGConfig from './thesisManage/earlyWarning'
import APPLYCASHMANAGEConfig from './fundsManage/applyCashManage'
import BANKSLIPIMPORTConfig from './fundsManage/bankSlipImport'
/* 系统管理员-送审单位列表 */
import DEPARTMENTConfig from './systemManage/department'
/* 送审单位-送审单位列表 */
import DEPARTMENT2Config from './systemManage/department2'
/* 系统管理员-派送单位列表 */
import EMPLOYERConfig from './systemManage/employer'
import EMPLOYER2Config from './systemManage/employer2' // 一级派送管理员-派送单位列表
/* 一级送审单位-全委托送审 */
/* 院系管理 */
import ACADEMYCONFIGConfig from './systemManage/academyConfig'
/* 评阅规则管理 */
import FUREVIEWRULECONFIGConfig from './configManage/fuReviewRuleConfig'
/* 导出字段配置 */
import FUEXPORTFIELDCONFIGConfig from './configManage/fuExportFieldConfig'
/* 批次设置 */
import FUBATCHCONFIGConfig from './allAuthorize/fuBatchConfig'
/* 论文上传 */
import FUUPLOADTHESISConfig from './allAuthorize/fuUploadThesis'
/* 论文送审 */
import FUSENDPAPERConfig from './allAuthorize/fuSendPaper'
/* 论文进度 */
import FUPROCESSOFTHESISConfig from './allAuthorize/fuProcessOfThesis'
/* 经费管理 */
import APPLYCASHConfig from './fundsManage/applyCash'
/* 历史账单管理 */
import HISTORYBILLConfig from './fundsManage/historyBill'
/* 论文催评 */
import PROMPTREVIEWConfig from './customerThesis/promptReview'
/* 催评单位 */
import PROMPTUNITConfig from './customerThesis/promptUnit'
/* 评阅论文 */
import REVIEWPAPERSConfig from './customerThesis/reviewPapers'
/* 费用管理 */
import FEEMANAGEConfig from './customerThesis/feeManage'
/* 评阅结果补录 */
import ADDRECORDRESULTConfig from './customerThesis/addRecordResult'
/* 学科评估 */
import WHEELSUBJECTASSESSConfig from './subjectAssess/wheelSubjectAssess'
/* 指派记录 */
import ASSIGNEDRECORDConfig from './thesisManage/assignedRecord'

export default {
  ACADEMYCONFIGConfig,
  USERConfig,
  EXPERTConfig,
  UNITEXPERTConfig,
  SENDEXPERTConfig,
  SENDEXPERTFROMUNITConfig,
  SENDUNITConfig,
  BATCHSENDEXPERTConfig,
  BATCHSENDEXPERTFROMUNITConfig,
  BATCHSENDUNITConfig,
  BATCHSENDUNITFROMUNITConfig,
  MENUConfig,
  ROLEConfig,
  UNITConfig,
  THESISConfig,
  RETURNTHESISConfig,
  REVIEWEDTHESISConfig,
  UPLOADTHESISConfig,
  PROCESSOFTHESISConfig,
  ACADEMYPROCESSOFTHESISConfig,
  MATCHEXPERTConfig,
  STAYRECEIVEDTHESISConfig,
  UNITUPLOADTHESISConfig,
  UNITUPLOADTHESIS2Config,
  EARLYWARNINGConfig,
  CUSTOMERConfig,
  APPLYCASHMANAGEConfig,
  HISTORYBILLConfig,
  BANKSLIPIMPORTConfig,
  DEPARTMENTConfig,
  DEPARTMENT2Config,
  EMPLOYERConfig,
  EMPLOYER2Config,
  FUREVIEWRULECONFIGConfig,
  FUEXPORTFIELDCONFIGConfig,
  FUBATCHCONFIGConfig,
  FUUPLOADTHESISConfig,
  FUSENDPAPERConfig,
  FUPROCESSOFTHESISConfig,
  APPLYCASHConfig,
  PROMPTREVIEWConfig,
  PROMPTUNITConfig,
  REVIEWPAPERSConfig,
  FEEMANAGEConfig,
  ADDRECORDRESULTConfig,
  WHEELSUBJECTASSESSConfig,
  ASSIGNEDRECORDConfig
}



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/index.js